export const CLEANUP_STATE = 'CLEANUP_STATE'

export const cleanupState = () => ({
  type: CLEANUP_STATE
})
